import { clearFullCart } from "redux/slices/carts";
import { useAppDispatch, useAppSelector } from "./useRedux";
import { useMutation } from "react-query";
import cartService from "services/cart";
import { useAuth } from "contexts/auth/auth.context";

type Props = {
  onSuccess?: () => void;
  onError?: () => void;
  clearLocalCart?: boolean;
};

export default function useClearCart({
  onSuccess,
  onError,
  clearLocalCart = true,
}: Props) {
  const dispatch = useAppDispatch();
  const { user } = useAuth();
  const { cart } = useAppSelector((state) => state.carts);
  const cartId = cart?.user_carts?.find(
    (userCart) => userCart?.user_id === user?.id,
  )?.cart_id;

  return useMutation({
    mutationFn: (cartIds?: number[]) => {
      if (cartIds?.length) {
        return cartService.delete({ ids: cartIds });
      } else {
        return cartService.delete({ ids: [cartId] });
      }
    },
    onSuccess: () => {
      if (clearLocalCart) {
        dispatch(clearFullCart());
      }
      if (onSuccess) {
        onSuccess();
      }
    },
    onError: () => {
      if (onError) {
        onError();
      }
    },
  });
}
